import { formatDateRangeForAPICall } from "@shared/charts/formatDate";
import { DateRange } from "@shared/components/DateRangePicker";
import { SHERLOCK_CHANGES } from "@shared/http/apiTypes/sherlockApiTypes";
import { useEffect, useState } from "react";

export default function useSherlockSettingsValues() {
  const queryParams = new URLSearchParams(window.location.search);

  const [dateRange, setDateRange] = useState<DateRange>(() => {
    const startDateFromUrl = queryParams.get("startDate");
    const endDateFromUrl = queryParams.get("endDate");

    if (startDateFromUrl && endDateFromUrl)
      return {
        startDate: new Date(startDateFromUrl),
        endDate: new Date(endDateFromUrl),
      };

    const today = new Date();
    today.setUTCDate(today.getUTCDate() - 1);
    today.setUTCHours(0, 0, 0, 0);

    const oneWeekAgo = new Date();
    oneWeekAgo.setUTCDate(oneWeekAgo.getUTCDate() - 7);
    oneWeekAgo.setUTCHours(0, 0, 0, 0);
    return { startDate: oneWeekAgo, endDate: today };
  });

  const onDateRangeChange = (newDateRange: DateRange) => {
    setDateRange(prevDateRange => ({
      startDate: newDateRange.startDate || prevDateRange.startDate,
      endDate: newDateRange.endDate || prevDateRange.endDate,
    }));
  };

  const campaignIdFromUrl = queryParams.get("campaignId");
  const metricFromUrl = queryParams.get("metric") || "ap_conversions";
  const changesFromUrl = queryParams.get("changes") || Object.keys(SHERLOCK_CHANGES).join(",");

  const { startDate, endDate } = formatDateRangeForAPICall(dateRange);
  useEffect(() => {
    if (!startDate || !endDate) return;

    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("startDate", startDate);
    queryParams.set("endDate", endDate);

    if (campaignIdFromUrl) queryParams.set("campaignId", campaignIdFromUrl);
    queryParams.set("metric", metricFromUrl);
    queryParams.set("changes", changesFromUrl);

    history.replaceState(null, "", "?" + queryParams.toString());
  }, [startDate, endDate, campaignIdFromUrl, metricFromUrl, changesFromUrl]);

  return {
    dateRange,
    onDateRangeChange,
    campaignIdFromUrl,
    metricFromUrl,
    changesFromUrl,
  };
}
